import { Weapon, type WeaponConfig } from './Weapon';

const DUAL_REVOLVER_CONFIG: WeaponConfig = {
  id: 'dual_revolver',
  name: 'Парный Револьвер',
  price: 100,
  fireRateMs: 125,
  bulletsPerShot: 1,
  spreadDeg: 0,
  soundKey: 'pistol_shot',
  soundVolume: 0.4,
  shakeShoot: null,
  magazineSize: 12,
  reloadTimeMs: 1275,
  fireMode: 'single',
  isDual: true,
  bulletWidth: 4,
  bulletHeight: 2,
};

export function createDualRevolver(): Weapon {
  return new Weapon(DUAL_REVOLVER_CONFIG);
}
